export default "__VITE_ASSET__0a61c839__"